import { PaginationType } from "@/components/Pagination/schema";
import { atom } from "jotai";


export const discountPaginationAtom = atom<PaginationType>({
    page: 1,
    pageSize: 5,
})